import { render, staticRenderFns } from "./simple-gradient.vue?vue&type=template&id=1ee503f8&scoped=true&"
import script from "./simple-gradient.vue?vue&type=script&lang=js&"
export * from "./simple-gradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee503f8",
  null
  
)

export default component.exports